import BaseService from "../BaseService";
import _ from "lodash";

class ProductTagService extends BaseService {
    list = async ({ info } = {}) => {
        var data = await this._api.post("/store/product_tag/list", { info });
        return data;
    };





}
export default ProductTagService;
